<template>
	<div class="pro_main">
		<div class="prompt" v-if="prompt_show">适用于电商类商品推广，以商品为核心
		<i class="el-dialog__close el-icon el-icon-close prompt_close" @click="prompt_show = false"></i>
		</div>
		
		<el-button type="primary" style="background-color: #0486FE;border: 0;" @click="open_dialogVisible3">+新增计划</el-button>
		<el-button type="primary" style="background-color: #FF8700;border: 0;" @click="open_dialogVisible">佣金规则设置</el-button>

		<el-table v-loading="loading" :data="tableData" style="width: 100%;min-height: 480px;margin-top: 15px;">
			<el-table-column label="商品图" align="center" width="120">
				<template slot-scope="scope">
					<img :src='scope.row.cover' class="hhrimg" />
				</template>
			</el-table-column>
			<el-table-column prop="title" label="商品名" align="center" width="250">
				<template slot-scope="scope">
					<el-tooltip placement="top" v-model="scope.row.showTooltip_p" :open-delay="700" effect="dark"
						:disabled="!scope.row.showTooltip_p">
						<div slot="content">{{scope.row.title}}</div>
						<div @mouseenter="showTips($event,scope.row)"
							style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #333333;text-overflow: ellipsis; display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical; overflow: hidden;word-break: break-all;">
							{{scope.row.title}}</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="price" label="价格" align="center">
			</el-table-column>
			<el-table-column label="佣金率" align="center">
				<template slot-scope="scope">
					{{scope.row.commission_rate}}%
				</template>
			</el-table-column>
			
			<el-table-column prop="save" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click="set_status(scope.row.status, scope.row.id, scope.$index)" type="text" size="medium">
						{{scope.row.status == 1?'取消推广':'推广'}}
					</el-button>
					<el-button type="text" size="medium" @click="open_dialogVisible2(scope.row.id, scope.row.commission_rate, scope.$index)">修改佣金比例</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;" v-if="tableData.length > 0">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
			</el-pagination>
		</div>
		
		<el-dialog width="424px" title="默认佣金规则设置" :visible.sync="dialogVisible" :before-close="close_dialogVisible" :close-on-click-modal='false'>
			<P style="font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #666666;">
				设定后再次发布商品时将会自动填写默认分销佣金率
			</P>
			<P style="font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #666666;margin-bottom: 20px;">
				可在产品中设置单独佣金率（该规则不会更改已有商品的佣金率）
			</P>
			<el-input v-model.number="commission" maxlength="2" oninput="value=value.replace(/[^\d]/g,'')"
				autocomplete="off" :placeholder="'填写佣金率2-'+max_rate+'区间的整数'">
				<template slot="append">%</template>
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close_dialogVisible">取 消</el-button>
				<el-button type="primary" @click="set_commission">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog width="424px" title="推广佣金规则设置" :visible.sync="dialogVisible2" :before-close="close_dialogVisible2" :close-on-click-modal='false'>
			<el-input v-model.number="set_commission_rate" maxlength="2" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" :placeholder="'填写佣金率2-'+max_rate+'区间的整数'">
				<template slot="append">%</template>
			</el-input>
			<div slot="footer" class="dialog-footer">
				<el-button @click="close_dialogVisible2">取 消</el-button>
				<el-button type="primary" @click="set_commission2">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog width="680px" title="选择商品" :visible.sync="dialogVisible3" :before-close="close_dialogVisible3" :close-on-click-modal='false'>
			<div v-if="prolist.length > 0">
				<div class="pop-list">
					<div class="pop-item" v-for="(item, index) in prolist" :key="item.id">
						<img class="pop-cover" :src="item.cover" alt="">
						<div class="pop-info">
							<div class="pro-title" style="text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;word-break: break-word;">
								{{item.title}}
							</div>
							<div class="pro-price">
								<div class="price">
									¥{{item.price}}
								</div>
								<div class="stock">
									库存：{{item.stock}}
								</div>
								<div class="rate">
									佣金：
									<div v-if="item.tui == 1">{{item.commission_rate}}%</div>
									<div :class="item.error == 1 ? 'input-error' : ''" v-else>
										<el-input size="mini" maxlength="2" oninput="value=value.replace(/[^\d]/g,'')" autocomplete="off" :placeholder="'填写2-'+ max_rate +'区间的整数'" v-model="item.commission_rate" style="width: 195px;">
										  <template slot="append">%</template>
										</el-input>
									</div>
								</div>
							</div>
						</div>
						<div class="pop-button" @click="joinPop(index)" v-if="!item.tui">立即推广</div>
					</div>
				</div>
				<!-- 分页器 -->
				<div class="block" style="padding: 30px 30px 10px 30px;" v-if="prolist.length > 0">
					<el-pagination background align='center' @size-change="handleSizeChange2"
						@current-change="handleCurrentChange2" :current-page="currentPage2" :page-size="pageSize"
						layout="total, prev, pager, next, jumper" :pager-count='5' :total="total2">
					</el-pagination>
				</div>
			</div>
			<div class="empty" v-else>
				<img src="../../assets/img/goods/empty_pop.png">
				<div>没有可推广的商品，您可前往商品库添加商品</div>
			</div>
		</el-dialog>
		
		<el-dialog class="my-dialog" :title="info.title" :visible.sync="show" :show-close="false" :before-close="close">
			<div class="my-date">
				<span>更新时间：{{info.entry_time}}</span>
				<span class="margin-left-30">生效时间：{{info.version_time}}</span>
			</div>
			<div class="my-editor">
				<quill-editor class="myQuillEditor" ref="text" v-model="info.content" disabled="disabled" />
			</div>
			<div slot="footer">
				<el-button type="primary" @click="know">知道了</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getDataProduct,
		set_commission,
		set_product_commission,
		updateStatus,
		getUnpopList,
		agreeProtocol,
		pop
	} from '@/api/goods';
	import {
		quillEditor
	} from 'vue-quill-editor';
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';
	export default {
		name: '',
		components: {
			quillEditor
		},
		data() {
			return {
				max_rate: 22,
				open_union: 0,
				activeName: 'all',
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true,
				tableData: [],
				dialogVisible: false,
				dialogVisible2: false,
				currentPage2: 0,
				total2: 0, // 总条数
				dialogVisible3: false,
				prolist: [],
				commission: '', //佣金率
				set_id: 0,
				set_commission_rate: '',
				
				show: false,
				info: {
					title: '鲸品联盟开通协议',
					entry_time: '2022年5月11日',
					version_time: '2022年5月11日',
					content: '<h2>提示条款</h2><p>欢迎您与北京爱群游网络信息技术有限公司共同签署本《鲸品联盟开通协议》（下称“本协议”）并使用鲸品联盟服务！</p><p>各服务条款前所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。为维护您自身权益，建议您仔细阅读各条款具体表述。</p><p>【审慎阅读】您在申请开通流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容。</p><p>【签约动作】当您按照开通页面提示，阅读并同意本协议且完成全部开通程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与我们达成一致，成为鲸品联盟用户。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止开通程序。</p><br/><h2>一、协议范围</h2><p>1.1签约主体</p><p>【平等主体】本协议由您与我们共同缔结，本协议对您与我们均具有合同效力。</p><p>1.2品牌商规则</p><p>由于互联网高速发展，我们本协议列明的条款并不能完整罗列并覆盖您与我们所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，我们有权基于运营需要，公布、调整鲸品联盟的规则，对于影响您权利义务的重大规则，我们将提前至少7日公布。</p><h2>二、合作模式</h2><p>您确认，基于本协议而产生的合作分销商仅作为其商品或团购活动普通计划/普通计划/定向计划/专属计划的推广宣传方，为保证产品质量及消费者的其他合法权益，分销商推广您的商品或团购活动普通计划/普通计划/定向计划/专属计划所产生的销售订单均由您供货并提供产品质量售后服务，消费者如有开票需求的亦由您提供。</p><p>2.1销售主体及责任承担：该模式下的分销商仅作为其商品或团购活动普通计划/普通计划/定向计划/专属计划的推广宣传方，为保证产品质量及消费者的其他合法权益，分销商推广品牌商的商品或团购活动普通计划/普通计划/定向计划/专属计划所产生的销售订单均由您供货并提供产品质量问题保障、售后服务，消费者如有开票需求由您提供。</p><p>2.2技术服务费：通过鲸品联盟产生的订单，我们有权向您收取销售商品对应的类目扣点收取相应的技术服务费。商品类目扣点明细见《技术服务费管理规范》。</p><p>2.3货款结算：订单完成后，您的货款会进入至您的特约商户号中，您自主登录微信商户平台进行提现即可。</p><p>2.4推广费用：您需向您的运营账户中充值相应的推广费用，该费用用于支付根据您所设置的商品或团购活动普通计划/定向计划/专属计划佣金比例，向分销商支付相对应的分销订单佣金。（推广费最低充值1000元）</p><p>2.3与2.4条款结算规则明细见《鲸选联盟费用结算说明》</p><h2>三、鲸品联盟服务及准则</h2><p>【分销商品或团购活动普通计划/普通计划/定向计划/专属计划发布】通过鲸品联盟提供的服务，您有权通过文字、图片、视频等形式在鲸品联盟上发布分销商品或团购活动普通计划/普通计划/定向计划/专属计划。</p><p>【禁止销售范围】您应当确保您对您在鲸品联盟上发布的分销商品或团购活动普通计划/普通计划/定向计划/专属计划享有相应的权利，您不得在鲸品联盟上销售以下商品或团购活动普通计划/普通计划/定向计划/专属计划以下服务：</p><p>（一）国家禁止或限制的；</p><p>（二）侵犯他人知识产权或其它合法权益的；</p><p>（三）鲸品联盟规则或我们与您单独签署的协议中已明确说明不适合在鲸品联盟上销售及/或提供的。</p><p>【交易秩序保障】您应当遵守诚实信用原则，确保您所发布的分销商品或团购活动普通计划/普通计划/定向计划/专属计划信息真实、与您实际所销售的分销商品或团购活动普通计划/普通计划/定向计划/专属计划的服务相符，并在交易过程中切实履行您的交易承诺。您应当维护鲸品联盟市场良性竞争秩序，不得贬低、诋毁竞争对手，不得干扰鲸品联盟上进行的任何交易、活动，不得以任何方式干扰或试图干扰鲸品联盟的正常运作。</p><p>【消费者保障】您同意，除法律法规规定的特殊产品外，您应认真履行买家付款完成后24/48小时内发货以及7天无理由退换货，否则按照平台管理规则的有关规则执行。以上维权不适用于买卖双方已就发货时间和售后服务沟通一致的情况。如买卖双方在交易中就发货时间和售后服务发生纠纷，其中任何一方可以以聊天记录证明。售后服务发生纠纷，其中任何一方可以以聊天记录证明。维权问题您与分销商首先通过协商解决，协商不成的，可提交我们处理。</p><p>【促销及推广】您有权自行决定分销商品或团购活动普通计划/普通计划/定向计划/专属计划的促销及推广方式，您的促销推广行为应当符合国家相关法律法规及鲸品联盟的规则。</p><p>【依法纳税】依法纳税是每一个公民、企业应尽的义务，您应对销售额/营业额超过法定免征额部分及时、足额地向税务主管机关申报纳税。</p><p>【分销商品或团购活动普通计划/普通计划/定向计划/专属计划的销售】当您在鲸品联盟销售商品或团购活动普通计划/普通计划/定向计划/专属计划时，请您务必仔细确认交易订单所购商品或团购活动普通计划/普通计划/定向计划/专属计划的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并核实您的联系地址、电话、收货人等信息。如上述交易行为产生的法律后果均由您承担。您的销售行为应当基于真实的消费需求，不得存在对商品或团购活动普通计划/普通计划/定向计划/专属计划实施恶意销售等扰乱鲸品联盟正常交易秩序的行为。基于维护鲸品联盟交易秩序及交易安全的需要，我们发现上述情形时可主动执行关闭相关交易订单等操作。您有义务保证销售的商品或团购活动普通计划/普通计划/定向计划/专属计划均为原包装正规品，严禁销售三无产品、假冒伪劣产品（含水货、仿冒品），否则我们有权要求您按该商品或团购活动普通计划/普通计划/定向计划/专属计划销售总额的十倍标准向消费者承担赔偿责任。如您销售商品或开展团购活动普通计划/普通计划/定向计划/专属计划的过程中，在质量、性能、外观方面存在缺陷或瑕疵，您应及时向消费者提供退货/换货服务。此种情形下，如我方因此受到到经济及名誉方面损失，您应赔偿我们遭受的全部损失。如遇商品或团购活动普通计划/普通计划/定向计划/专属计划引起的质量或其他纠纷，您需提供第三方部门出具的权威质检报告或原厂证明文件等，如您拒绝提供、怠于处理或提供虚假证明的，您同意我们有权按照中国相关法律法规规定向消费者先行赔偿，并从您的保证金及推广费中扣除我方先行支付的赔偿款。</p><p>【消费者信息保护】消费者下单预定后，您将通过鲸品联盟获取消费者的地址、通讯方式等信息。您保证对消费者的个人信息必须严格保护，不得泄露、出售或向他人提供。</p><p>【资质要求】您在鲸品联盟销售商品，除企业证照之外，其他资质详见《商家资质管理规范》。</p><p>【商品或团购活动普通计划/定向计划/专属计划标签】您应确保商品标签（产品包装、产品吊牌、水洗标等）符合国家规定，产品标签应含有：品名、规格、产地、生产日期、材质/原料/成分表、生产商名称、生产商地址和联系方式、委托方名称、委托方地址和联系方式，以下商品或团购活动普通计划/定向计划/专属计划还必须标明：</p><p>食品：生产许可证号、保质期等</p><p>电子数码/家电类：电压、功率等</p><p>化妆品类：卫妆字号、保质期等</p><p>服装/鞋靴类：执行标准、安全技术类别等</p><p>饰品类：材质等级、贵金属含量等</p><p>书籍类：ISBN号等</p><p>如因产品标签问题引起的纠纷和赔偿由您承担。</p><h2>四、责任限制</h2><p>4.1我们依法律规定承担基础保障义务，但无法对于因电信故障、政府行为、司法行政机关的命令、黑客攻击、网络拥堵、软件病毒、通讯故障等不可抗力或不可控制的第三方因素给您造成的损害结果承担责任。</p><p>4.2您理解基于平台产品的特殊性，我们有权定期或者不定期对提供网络服务的产品、平台、相关设备进行维护，对于因此给您造成的损害后果，我们无须承担责任。</p><h2>五、信息的保证及授权</h2><p>5.1【商品或团购活动普通计划/定向计划/专属计划信息的发布】您声明并保证，您对您所发布的商品或团购活动普通计划/定向计划/专属计划信息拥有相应、合法的权利。否则，我们可对您发布的商品或团购活动普通计划/定向计划/专属计划信息依法或依本协议进行删除或屏蔽。</p><p>5.2【禁止性信息】您应当确保您所发布的信息不包含以下内容：</p><p>（一）违反国家法律法规禁止性规定的；</p><p>（二）政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p><p>（三）欺诈、虚假、不准确或存在误导性的；</p><p>（四）侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</p><p>（五）侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</p><p>（六）存在可能破坏、篡改、删除、影响鲸品联盟任何系统正常运行或未经授权秘密获取鲸品联盟及其他商户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</p><p>（七）其他违背社会公共利益或公共道德或依据相关鲸品联盟规则的规定不适合在鲸品联盟上发布的。</p><p>5.3【授权使用】对于您提供及发布的信息，在版权保护期内您免费授予我们及其关联公司获得许可使用权利及再授权给其他第三方使用的权利。您同意我们及其关联公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。</p><h2>六、违约及处理</h2><p>6.1违约认定</p><p>发生如下情形之一的，视为您违约：</p><p>（一）使用鲸品联盟服务时违反有关法律法规规定的；</p><p>（二）违反本协议或本协议补充协议（即本协议第1.2条）约定的。</p><p>为适应移动电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，我们可在鲸品联盟规则中约定违约认定的程序和标准。如：我们可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</p><p>6.2违约处理措施</p><p>您在鲸品联盟上发布的信息构成违约的，我们可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的商品或团购活动普通计划/定向计划/专属计划进行下架、监管。</p><p>您在鲸品联盟上实施的行为，或虽未在鲸品联盟上实施但对鲸品联盟及其商户产生影响的行为构成违约的，我们可依据相应规则中止向您提供部分或全部服务、划扣保证金、违约金等处理措施。如您的行为构成根本违约的，我们可查封您的账户，终止向您提供服务。</p><p>当您违约的同时存在欺诈、售假、盗用他人账户等特定情形或您存在危及他人交易安全或账户安全风险时，我们会依照您行为的风险程度对您的资金账户采取资金冻结等强制措施。</p><p>我们可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在鲸品联盟上予以公示。</p><p>6.3赔偿责任</p><p>如您的行为使我们及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿我们及/或其关联公司的上述全部损失。</p><p>如您的行为使我们及/或其关联公司遭受第三人主张权利，我们及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。</p><p>如因您的行为使得第三人遭受损失，我们及/或其关联公司出于社会公共利益保护或消费者权益保护目的，可自您的账户中划扣相应款项进行支付。如您的账户余额或保证金不足以支付相应款项的，您同意委托我们使用自有资金代您支付上述款项，您应当返还该部分费用并赔偿因此造成我们的全部损失。</p><p>您同意我们可自您的账户中划扣相应款项支付上述赔偿款项。如您账户中的款项不足以支付上述赔偿款项的，我们及/或关联公司可直接抵减您在我们及/或其关联公司其它协议项下的权益，并可继续追偿。</p><p>6.4特别约定</p><p>【商业贿赂】如您向我们及/或其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，我们可立即终止与您的所有合作并向您收取违约金及/或赔偿金，该等金额以我们因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。</p><p>【关联处理】如您因严重违约导致我们终止本协议时，出于维护平台秩序及保护消费者权益的目的，我们及/或其关联公司可对与您在其他协议项下的合作采取中止甚或终止协议的措施。</p><h2>七、协议的变更</h2><p>我们可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将在鲸品联盟上以公示形式通知您。</p><p>如您不同意变更事项，您有权于变更事项确定的生效日前联系我们反馈意见。如反馈意见得以采纳，我们将酌情调整变更事项。登录或继续使用鲸品联盟服务将表示您同意已生效的变更事项。</p><h2>八、协议的终止</h2><p>8.1终止的情形</p><p>出现以下情况时，我们可以终止本协议：</p><p>（一）您违反本协议约定，我们依据违约条款终止本协议的；</p><p>（二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，我们依据鲸品联盟规则对您的账户予以查封的；</p><p>（三）除上述情形外，因您多次违反鲸品联盟规则相关规定且情节严重，我们依据鲸品联盟规则对您的账户予以查封的；</p><p>（四）您的账户被我们依据本协议回收的；</p><p>（五）您在鲸品联盟有欺诈、发布或销售假冒伪劣/侵权商品或团购活动普通计划/定向计划/专属计划、侵犯他人合法权益或其他严重违法违约行为的；</p><p>（六）其它应当终止服务的情况。</p><p>8.2协议终止后的处理</p><p>【供应商信息披露】本协议终止后，除法律有明确规定外，我们无义务向您或您指定的第三方披露您账户中的任何信息。</p><p>【我们的权利】本协议终止后，我们仍享有下列权利：</p><p>（一）继续保存您留存于鲸品联盟的本协议项下所列的各类信息；</p><p>（二）对于您过往的违约行为，我们仍可依据本协议向您追究违约责任。</p><p>【交易处理】本协议终止后，对于您在本协议存续期间产生的交易订单，我们可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。</p><h2>九、法律适用、管辖与其他</h2><p>【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</p><p>【管辖】您因使用鲸品联盟服务所产生及与鲸品联盟服务有关的争议，由我们与您协商解决。协商不成时，任何一方均可向上海市宝山区人民法院提起诉讼。</p><p>【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>'
				},
				prompt_show:true
			}
		},
		created() {
			let keypage = localStorage.getItem('keypage');
			let activeName = localStorage.getItem('activeName');
			if (keypage) {
				this.currentPage = parseInt(keypage);
				this.activeName = activeName
				localStorage.setItem('keypage', '')
				localStorage.setItem('activeName', '')
			}
			this.getlist();
		},
		methods: {
			//切换标签页
			handleClick(tab, event) {
				this.currentPage = 0;
				this.getlist();
			},
			getlist() {
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getDataProduct({
					start: currentPage * 10,
					status: this.activeName
				}).then(res => {
					if (res.code == 0) {
						this.loading = false;
						this.total = res.data.count;
						this.commission = res.data.commission_rate;
						this.tableData = res.data.list;
						this.max_rate = res.data.max_rate;
						this.open_union = res.data.open_union;
						/*  1、有分销商品且未开通“鲸品联盟”，则弹框显示协议，仅有一个按钮“知道了”
							2、无分销商品且未开通“鲸品联盟”，进入开通鲸品联盟页面 */
						if (!this.open_union) {
							if (this.total > 0) {
								this.show = true;
							} else {
								this.goIntroduce();
							}
						}
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getUnpop() {
				let currentPage = this.currentPage2;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getUnpopList({
					start: currentPage * 10,
				}).then(res => {
					if (res.code == 0) {
						this.loading2 = false;
						this.total2 = res.data.count;
						var prolist = res.data.list;
						prolist.map((item) => {
							item.commission_rate = this.commission ? this.commission : '';
							item.tui = 0;
							item.error = 0;
						})
						this.prolist = prolist;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getlist();
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange2(val) {
				this.currentPage2 = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange2(val) {
				this.currentPage2 = val;
				this.getUnpop();
			},
			//设置统一佣金率
			set_commission() {
				if (this.commission < 2 || this.commission > this.max_rate) {
					this.$message.error('佣金率请填写2-' + this.max_rate + '区间的整数');
					return false;
				}
				set_commission({
					commission_rate: this.commission
				}).then(res => {
					this.dialogVisible = false
					if (res.code == 0) {
						this.$message.success(res.message);
						this.getlist();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//open
			open_dialogVisible() {
				this.dialogVisible = true
			},
			//close
			close_dialogVisible() {
				this.dialogVisible = false
				this.getlist();
			},
			set_commission2() {
				if (this.set_commission_rate < 2 || this.set_commission_rate > this.max_rate) {
					this.$message.error('佣金率请填写2-' + this.max_rate + '区间的整数');
					return false;
				}
				set_product_commission({
					id: this.set_id,
					commission_rate: this.set_commission_rate
				}).then(res => {
					this.dialogVisible2 = false
					if (res.code == 0) {
						this.tableData[this.set_index].commission_rate = this.set_commission_rate;
						this.$message.success(res.message);
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//open
			open_dialogVisible2(id,commission_rate, index) {
				this.dialogVisible2 = true;
				this.set_id = id;
				this.set_commission_rate = commission_rate;
				this.set_index = index;
			},
			//close
			close_dialogVisible2() {
				this.dialogVisible2 = false
			},
			set_status(status, id, index) {
				if (status == 1) {
					this.$confirm('确认取消推广?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  type: 'warning'
					}).then(() => {
					  updateStatus({
					  	product_id: id,
					  	op: 'notui',
					  }).then(res => {
					  	if (res.code == 0) {
					  		this.tableData[index].status = 0;
					  		this.$message.success(res.message);
					  	} else {
					  		this.$message.error(res.message);
					  	}
					  })
					}).catch(() => {
						
					});
				} else {
					updateStatus({
						product_id: id,
						op: 'tui',
					}).then(res => {
						if (res.code == 0) {
							this.tableData[index].status = 1;
							this.$message.success(res.message);
						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			goIntroduce() {
				this.$router.push({
					path: '/goods/introduce',
					query: {}
				});
			},
			close() {
				// this.show = false;
			},
			know() {
				agreeProtocol({}).then(res => {
					if (res.code == 0) {
						this.show = false;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			open_dialogVisible3() {
				this.dialogVisible3 = true;
				this.getUnpop();
			},
			close_dialogVisible3() {
				this.dialogVisible3 = false;
			},
			joinPop(index) {
				var product_id = this.prolist[index].id;
				var commission_rate = this.prolist[index].commission_rate;
				if (commission_rate < 2 || commission_rate > this.max_rate) {
					this.$message.error('佣金率请填写2-' + this.max_rate + '区间的整数');
					this.prolist[index].error = 1;
					return false;
				}
				pop({
					product_id: product_id,
					commission_rate: commission_rate
				}).then(res => {
					if (res.code == 0) {
						this.$message.success(res.message);
						this.prolist[index].tui = 1;
						console.log(this.prolist)
						this.currentPage = 1;
						this.getlist();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			showTips(obj, row) {
				/*obj为鼠标移入时的事件对象*/
				/*width为文本在页面中所占的宽度，创建标签，加入到页面，获取width,最后在移除*/
				let TemporaryTag = document.createElement('span');
				TemporaryTag.innerText = row.title;
				TemporaryTag.className = 'getTextWidth';
				document.querySelector('body').appendChild(TemporaryTag);
				let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
				document.querySelector('.getTextWidth').remove();
				/*cellWidth为表格容器的宽度*/
				const cellWidth = obj.target.offsetWidth
				/*当文本宽度小于||等于容器宽度两倍时，代表文本显示未超过两行*/
				currentWidth <= (2 * cellWidth) ? row.showTooltip_p = false : row.showTooltip_p = true;
			}
		}
	}
</script>

<style scoped="scoped">
	.father-main {
		overflow: auto;
	}

	.support-box .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}

	.support-box .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}

	.pro_main {
		min-height: 88vh;
		background-color: #ffffff;
		padding-left: 20px;
		padding-top: 20px;
		padding-right: 10px;
	}

	.pro_main .el-tabs__header {
		margin: 0;
	}

	.hhrtx {
		display: inline-block;
		vertical-align: middle;
		padding: 0 15px;
	}

	.hhrimg {
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 2px;
	}

	.el-tooltip__popper {
		max-width: 20%;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}
	
	.empty {
		width: 100%;
		height: 400px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}
	.empty img {
		width: 126px;
		height: 140px;
	}
	.empty div {
		margin-top: 10px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #999999;
		line-height: 17px;
	}
	
	.pop-list {
		height: 300px;
		overflow-y: scroll;
	}
	.pop-item {
		padding: 10px 10px 10px 0;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #EEEEEE;
	}
	.pop-cover {
		width: 40px;
		height: 40px;
		border-radius: 2px;
	}
	.pop-info {
		margin-left: 10px;
	}
	.pro-title {
		width: 470px;
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 14px;
	}
	.pro-price {
		margin-top: 8px;
		display: flex;
		align-items: center;
	}
	.pro-price .price {
		width: 90px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #F56C6C;
		line-height: 20px;
	}
	.pro-price .stock {
		margin-left: 10px;
		width: 90px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 17px;
	}
	.pro-price .rate {
		margin-left: 10px;
		display: flex;
		align-items: center;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		line-height: 17px;
	}
	.input-error >>> .el-input__inner, .input-error >>> .el-input__inner:focus {
		border-color: #F56C6C;
	}
	.pop-button {
		margin-left: 10px;
		padding: 5px 15px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 17px;
		background: #0486FE;
		border-radius: 2px;
		cursor: pointer;
	}
	
	.my-dialog>>>.el-dialog {
		width: 450px;
	}
	
	.my-dialog>>>.el-dialog__header {
		padding: 15px 15px 0 15px;
		font-size: 18px;
		color: #333333;
		line-height: 30px;
	}
	
	.my-dialog>>>.el-dialog__body {
		padding: 0 15px 15px 15px;
	}
	
	.my-dialog>>>.el-dialog__footer {
		padding: 0 20px 15px 0;
	}
	
	.my-dialog>>>.el-dialog__footer .el-button--primary {
		background-color: #0486FE;
		border-color: #0486FE;
	}
	
	.my-dialog>>>.my-date {
		padding: 5px 0 10px 0;
		font-size: 12px;
		color: #666666;
		line-height: 17px;
	}
	
	.my-editor {
		padding-top: 15px;
		border-top: 1px solid #EEEEEE;
	}
	
	.my-editor>>>.ql-toolbar {
		display: none;
	}
	
	.my-editor>>>.ql-container {
		border: 0;
	}
	
	.my-editor>>>.ql-editor {
		padding: 0;
		height: 445px;
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	.margin-left-30 {
		margin-left: 30px;
	}
	
	.prompt{
		width:100%;
		height: 40px;
		background: #F2F2F2;
		border-radius: 4px;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #666666;
		line-height:40px;
		padding-left:20px;
		box-sizing: border-box;
		margin-bottom: 16px;
	}
	.prompt_close{
		float: right;
		font-size: 20px;
		margin-top: 11px;
		margin-right: 16px;
		cursor: pointer;
	}
</style>
